// @flow

import type { BundleType } from '@gandi/cart';

import type { FullState } from '../../../types';
import type { Bundle, BundleContent, BundleTotal } from '../../types';

const EMPTY_ARRAY: Array<void | string> = [];
export const BUNDLE_TYPE_POPULARITY = 'popularity';
// eslint-disable-next-line import/no-unused-modules
export const BUNDLE_TYPE_PROMO = 'promo';
export const DEFAULT_BUNDLE_TYPE = BUNDLE_TYPE_POPULARITY;

export const selectBundle = (
  state: FullState,
  type: BundleType,
): Bundle | void => state.domainSuggest?.bundles?.[type];

const selectBundleTotal = (
  state: FullState,
  type: BundleType,
): BundleTotal | void => {
  const bundle = selectBundle(state, type);
  return bundle ? bundle.total : undefined;
};

export const selectBundleContent = (
  state: FullState,
  type: BundleType = BUNDLE_TYPE_POPULARITY,
): BundleContent | typeof EMPTY_ARRAY => {
  const bundle = selectBundle(state, type);
  const valid = !!selectBundleTotal(state, type);
  return (bundle && valid && bundle.content) || EMPTY_ARRAY;
};

export const selectDefaultBundleContent = (
  state: FullState,
): BundleContent | typeof EMPTY_ARRAY =>
  selectBundleContent(state, DEFAULT_BUNDLE_TYPE);
